export default __webpack_public_path__ + "static/media/a1_889x500.9a6280f8.png";